module.exports = __webpack_public_path__ + "static/media/whiteswirl.415af0d1.png";